import React from 'react';
import Head from 'next/head.js';
import {
  Button,
  Size,
  Theme,
} from '@havenengineering/module-shared-library/dist/components/Button';

import { ClientContext } from '../../helpers/clientContext';
import styles from './AlreadyLoggedInNotice.module.scss';

type AlreadyLoggedInNoticeProps = {
  message?: string;
  clientContext: ClientContext | null;
};

export const AlreadyLoggedInNotice = ({
  message = 'Log in re-attempt',
  clientContext,
}: AlreadyLoggedInNoticeProps) => {
  const isOwners = clientContext?.name === 'Owners';
  const defaultContinueLink = isOwners ? 'https://owners.haven.com' : 'https://www.haven.com';
  const continueLink = clientContext?.errorContinueUrl || defaultContinueLink;

  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
        <meta name="googlebot" content="noindex" />
        <title>Session Error</title>
      </Head>
      <div className={styles.mainContainer}>
        <h1>{message}</h1>
        <p data-testid="reattempt-body-copy">
          Looks like you clicked back in the browser. Just so you know, you&apos;re already logged
          in. Click <strong>Continue</strong> to proceed.
        </p>
        <div>
          <Button
            data-testid={'continue-link'}
            theme={Theme.PRIMARY_THEME}
            scale={Size.MEDIUM_SIZE}
            className={styles.button}
            useAnchor
            href={continueLink}
          >
            Continue
          </Button>
        </div>
      </div>
    </>
  );
};
